var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 4.95226L9 0.507812L4.55556 4.95226",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.1745V12.2411C17 13.7346 17 14.4814 16.7094 15.0518C16.4537 15.5536 16.0457 15.9615 15.544 16.2172C14.9735 16.5078 14.2268 16.5078 12.7333 16.5078H5.26667C3.77319 16.5078 3.02646 16.5078 2.45603 16.2172C1.95426 15.9615 1.54631 15.5536 1.29065 15.0518C1 14.4814 1 13.7346 1 12.2411V11.1745M13.4444 4.95226L9 0.507812M9 0.507812L4.55556 4.95226M9 0.507812V11.1745",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8c31dee4d4c0e9a619eb218102246f95.svg";
export { ForwardRef as ReactComponent };